<template>
  <transition name="app-version-notice-fade">
    <div v-if="visible" class="app-version-notice">
      <div class="app-version-notice__content">
        <span class="app-version-notice__text">🎉 已发布新版本,刷新即可使用</span>
        <a-button size="small" class="app-version-notice__button" @click="refreshPage">立即刷新</a-button>
      </div>
    </div>
  </transition>
</template>

<script>
import {
    createVersionCheckUrl,
    hasEntryVersionChanged,
} from '@/utils/app-version'

const CHECK_INTERVAL = 60 * 1000

export default {
    name: 'AppVersionNotice',
    data() {
        return {
            visible: false,
            checking: false,
            entryHtml: '',
            timer: null,
        }
    },
    mounted() {
        this.startVersionCheck()
    },
    beforeDestroy() {
        this.stopVersionCheck()
    },
    methods: {
        /**
         * 启动入口文件轮询，首次请求只记录基准内容，避免用已挂载 DOM 造成误判。
         *
         * @returns {void}
         */
        startVersionCheck() {
            this.checkVersion()
            this.timer = window.setInterval(this.checkVersion, CHECK_INTERVAL)
        },
        /**
         * 停止轮询并释放定时器引用，避免全局组件销毁时留下后台任务。
         *
         * @returns {void}
         */
        stopVersionCheck() {
            if (!this.timer) {
                return
            }
            window.clearInterval(this.timer)
            this.timer = null
        },
        /**
         * 请求最新入口文件并判断是否发布了新版本，请求失败时静默等待下次轮询。
         *
         * @returns {Promise<void>}
         */
        async checkVersion() {
            if (this.checking || this.visible) {
                return
            }
            this.checking = true
            try {
                const url = createVersionCheckUrl(process.env.BASE_URL || '/', Date.now())
                const response = await window.fetch(url, {
                    cache: 'no-store',
                    headers: {
                        'Cache-Control': 'no-cache',
                    },
                })
                if (!response.ok) {
                    return
                }
                const html = await response.text()
                if (!this.entryHtml) {
                    this.entryHtml = html
                    return
                }
                if (hasEntryVersionChanged(this.entryHtml, html)) {
                    this.visible = true
                    this.$emit('change', true)
                }
            } catch (e) {
                // 网络抖动不打扰用户，下一轮继续检测即可。
            } finally {
                this.checking = false
            }
        },
        /**
         * 用户确认后刷新页面，加载最新静态资源。
         *
         * @returns {void}
         */
        refreshPage() {
            window.location.reload()
        },
    },
}
</script>

<style lang="less" scoped>
.app-version-notice {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  width: 100%;
  height: 44px;
  background: linear-gradient(90deg, #8b5cf6 0%, #7c3aed 54%, #8b5cf6 100%);
  box-shadow: 0 8px 24px rgba(76, 29, 149, 0.2);
  color: #fff;
}

.app-version-notice__content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}

.app-version-notice__text {
  overflow: hidden;
  max-width: calc(100vw - 132px);
  white-space: nowrap;
  text-overflow: ellipsis;
}

.app-version-notice__button {
  height: 28px;
  margin-left: 18px;
  border: 0;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
  font-weight: 600;
}

.app-version-notice__button:hover,
.app-version-notice__button:focus {
  background: rgba(255, 255, 255, 0.32);
  color: #fff;
}

.app-version-notice-fade-enter-active,
.app-version-notice-fade-leave-active {
  transition: opacity 0.2s ease;
}

.app-version-notice-fade-enter,
.app-version-notice-fade-leave-to {
  opacity: 0;
}
</style>
